import { Autocomplete, CircularProgress, TextField, SxProps, Theme } from '@mui/material';
import { useController } from 'react-hook-form';
import { HTMLUListElementAttributes } from 'shared/types';
interface SelectFieldProps<T> {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label: string;
  rules?: Object;
  error?: boolean;
  helperText?: string;
  readOnly?: boolean;
  options: T[];
  getOptionLabel(option: T): string;
  getOptionSelected(option: T, value: T): boolean;
  loading?: boolean;
  defaultValue?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function SelectField<T>({
  name,
  label,
  rules,
  error,
  helperText,
  readOnly,
  options,
  getOptionLabel,
  getOptionSelected,
  loading,
  fullWidth = true,
  defaultValue = '',
  disabled,
  sx,
}: SelectFieldProps<T>) {
  const {
    field: { ref, value, onChange },
  } = useController({ name, defaultValue, rules });

  return (
    <Autocomplete
      ref={ref}
      value={value}
      id={name}
      onChange={(_, value) => {
        onChange(value);
      }}
      disabled={disabled}
      options={options}
      sx={sx}
      fullWidth={fullWidth}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={getOptionSelected}
      data-testid={`${name}-combobox`}
      ListboxProps={{ 'data-testid': `${name}-listbox` } as HTMLUListElementAttributes}
      renderInput={params => (
        <TextField
          variant='outlined'
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: loading ? <CircularProgress color='inherit' size={20} /> : params.InputProps.endAdornment,
            readOnly,
          }}
        />
      )}
    />
  );
}
